import Guard from "vue-router-multiguard";
import { Middlewares } from "@/app/shared/services/app-router/middlewares";

import offersRoutes from "./offers/offers-routes";
import usersRoutes from "./users/user-routes";
import dealsRoutes from "./deals/deals-routes";
import notificationsRoutes from "./notifications/notifications-routes";
import economicsRoutes from "./economics/economics-routes";
import postbacksRoutes from "./postbacks/postbacks-routes";
import callsRoutes from "./calls/calls-routes";
import triggersRoutes from "./triggers/triggers-routes";
import eventsRoutes from "./events/events-routes";
import settingsRoutes from "./apps_settings/apps-settings-routes";
import moneyStatisticsRoutes from "./statistics/statistics-routes";
import applicationsRoutes from "./applications/applications-routes";

const adminRoutes = [
    {
        path: "/admin-login",
        name: "AdminLogin",
        component: () => import("./login"),
    },
    {
        path: "/admin",
        name: "AdminPanel",
        component: () => import("./panel"),
        beforeEnter: Guard([Middlewares.authRequired, Middlewares.adminAccess]),
        children: [
            ...offersRoutes,
            ...usersRoutes,
            ...dealsRoutes,
            ...notificationsRoutes,
            ...economicsRoutes,
            ...postbacksRoutes,
            ...callsRoutes,
            ...triggersRoutes,
            ...eventsRoutes,
            ...settingsRoutes,
            ...moneyStatisticsRoutes,
            ...applicationsRoutes,
        ],
    },
];

export default adminRoutes;
